import { Form, Select } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { useGetAllEntityStatusValues } from 'client/modules/cbi-entity/services/general-info/hooks/useGetAllEntityStatusValues';

export const CompanyStatusSelect = ({
  name,
  label,
  placeholder,
}: {
  name: NamePath;
  label: string;
  placeholder: string;
}) => {
  const { data: entityStatusValues, isFetching: isFetchingAllStatusValues } =
    useGetAllEntityStatusValues({ enabled: true });
  return (
    <Form.Item name={name} label={label}>
      <Select
        className="min-w-[200px]"
        mode="multiple"
        placeholder={placeholder}
        allowClear
        loading={isFetchingAllStatusValues}
        filterOption={(input, option) =>
          option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        options={entityStatusValues?.allEntityStatusValues.map((status) => ({
          value: status.idStatus,
          label: status.status,
        }))}
        labelInValue
      />
    </Form.Item>
  );
};
